import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  CompanyProfile,
  CompanyProfileObject,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';
@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: CompanyProfileObject, option?): UntypedFormGroup {
    let formBuilderGroup = this.formBuilder.group({
      ownerId: [entity.ownerId],
      company: this.formBuilder.group({
        id: [entity?.company?.id || null],
        accountId: [entity?.company?.accountId || null],
        endDate: [entity?.company?.endDate || null],
        name: [entity?.company?.name || null],
        legalForm: [entity?.company?.legalForm || null],
        representative: [entity?.company?.representative || null],
        representativeFunction: [
          entity?.company?.representativeFunction || null,
        ],
        creationDate: [entity?.company?.creationDate || null],
        taxSystem: [entity?.company?.taxSystem || null],
        taxResidence: [entity?.company?.taxResidence || null],
        codeSiret: [entity?.company?.codeSiret || null],
        isPublicSiret: [entity?.company?.isPublicSiret || true],
        rcs: [entity?.company?.rcs || null],
        lieuImmatriculationRcs: [
          entity?.company?.lieuImmatriculationRcs || null,
        ],
        societeCotee: [
          !_.isNil(entity?.company?.societeCotee)
            ? entity?.company?.societeCotee
            : false,
        ],
        societeCoteeMarche: [entity?.company?.societeCoteeMarche || null],
        socialCapital: [entity?.company?.socialCapital || null],
        valorisation: [entity?.company?.valorisation || null],
        tva: [entity?.company?.tva || null],
        codeAPE: [entity?.company?.codeAPE || null],
        activitySector: [entity?.company?.activitySector || null],
        bilanCA: [entity?.company?.bilanCA || null],
        bilanEquity: [entity?.company?.bilanEquity || null],
        bilanNetResult: [entity?.company?.bilanNetResult || null],
        bilanTresory: [entity?.company?.bilanTresory || null],
        bilanDebt: [entity?.company?.bilanDebt || null],
        bilanTax: [entity?.company?.bilanTax || null],
        bilanTotalBilan: [entity?.company?.bilanTotalBilan || null],

        bilanCAN1: [entity?.company?.bilanCAN1 || null],
        bilanEquityN1: [entity?.company?.bilanEquityN1 || null],
        bilanNetResultN1: [entity?.company?.bilanNetResultN1 || null],
        bilanTresoryN1: [entity?.company?.bilanTresoryN1 || null],
        bilanDebtN1: [entity?.company?.bilanDebtN1 || null],
        bilanTaxN1: [entity?.company?.bilanTaxN1 || null],
        bilanTotalBilanN1: [entity?.company?.bilanTotalBilanN1 || null],

        bilanCAN2: [entity?.company?.bilanCAN2 || null],
        bilanEquityN2: [entity?.company?.bilanEquityN2 || null],
        bilanNetResultN2: [entity?.company?.bilanNetResultN2 || null],
        bilanTresoryN2: [entity?.company?.bilanTresoryN2 || null],
        bilanDebtN2: [entity?.company?.bilanDebtN2 || null],
        bilanTaxN2: [entity?.company?.bilanTaxN2 || null],
        bilanTotalBilanN2: [entity?.company?.bilanTotalBilanN2 || null],

        addressSiegeSocial: [entity?.company?.addressSiegeSocial || null],
        addressSiegeAdministratif: [
          entity?.company?.addressSiegeAdministratif || null,
        ],
        beneficialOwner: [entity?.company?.beneficialOwner || null],
      }),
    });

    return formBuilderGroup;
  }

  generate(entity: CompanyProfile[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value.owners);
    formValue.forEach(item => {
      if (item?.company?.addressSiegeSocial?.country?.value) {
        item.company.addressSiegeSocial.country =
          item.company.addressSiegeSocial.country.value;
      }
      if (item?.company?.addressSiegeAdministratif?.country?.value) {
        item.company.addressSiegeAdministratif.country =
          item.company.addressSiegeAdministratif.country.value;
      }
    });
    return formValue;
  }
}
